export const aciFuton = {
    iconName: 'futon',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M4.243 12.655c-.364 0-.684.09-.894.215a.608.608 0 00-.189.164c-.027.04-.028.06-.028.065v1.832h17.736v-1.832c0-.004 0-.026-.028-.065a.607.607 0 00-.19-.164c-.209-.126-.53-.214-.893-.214H4.243zm0-1.132h15.514c.526 0 1.058.125 1.478.377.414.25.765.662.765 1.2v2.397a.566.566 0 01-.566.566H2.566A.566.566 0 012 15.497V13.1c0-.537.351-.95.765-1.199.42-.252.952-.377 1.478-.377z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M4.926 15.455c.302.081.48.391.4.693l-.651 2.43a.566.566 0 11-1.094-.293l.651-2.43a.566.566 0 01.694-.4zM19.074 15.455a.566.566 0 01.693.4l.652 2.43a.566.566 0 01-1.094.293l-.651-2.43a.566.566 0 01.4-.693zM3.2 5.353a2.227 2.227 0 011.404-.482h14.79c.51 0 1.016.165 1.405.482.391.32.64.782.64 1.293v5.442a.566.566 0 11-1.131 0V6.646c0-.13-.063-.283-.226-.416a1.097 1.097 0 00-.687-.227H4.604c-.275 0-.521.09-.688.227-.163.133-.225.287-.225.416v5.442a.566.566 0 11-1.132 0V6.646c0-.511.25-.973.64-1.293z',
                    fill: 'currentColor',
                },
            },
        ],
        circle: [
            { attr: { cx: '5.98', cy: '8.476', r: '.687', fill: 'currentColor' } },
            { attr: { cx: '9.994', cy: '8.476', r: '.687', fill: 'currentColor' } },
            { attr: { cx: '14.008', cy: '8.476', r: '.687', fill: 'currentColor' } },
            { attr: { cx: '18.019', cy: '8.476', r: '.687', fill: 'currentColor' } },
        ],
    },
};
